import styled from "@emotion/styled"
import { leadingNormal, radiusXl, spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { SkeletonComponent } from "./SkeletonComponent"

export const SkeletonInlineNotification = styled(SkeletonComponent)`
	height: ${leadingNormal};
	padding: ${spacingStaticMd};
    border-radius: ${radiusXl};
`
